import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: absolute;
  background-color: #fff;
  border: 1px solid #cccccc;
  width: 100%;
  z-index: 10;
  margin-top: -1px;
`

type ItemProps = {
  active?: boolean
}

export const Item = styled.div<ItemProps>`
  padding: 5px 10px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &:focus {
    background-color: #f5f5f5;
  }

  ${({ active }) =>
    active &&
    css`
      background-color: #f5f5f5;
    `}
`

export const Message = styled.div`
  text-align: center;
  padding: 5px 10px;
  color: #ccc;
`
